/* @ts-self-types="./web.d.ts" */

export class Caveat {
    static __wrap(ptr) {
        const obj = Object.create(Caveat.prototype);
        obj.__wbg_ptr = ptr;
        CaveatFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof Caveat)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CaveatFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_caveat_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get damage_type() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_caveat_damage_type(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get dr() {
        const ret = wasm.__wbg_get_caveat_dr(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {string} arg0
     */
    set damage_type(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_caveat_damage_type(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set dr(arg0) {
        wasm.__wbg_set_caveat_dr(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) Caveat.prototype[Symbol.dispose] = Caveat.prototype.free;

/**
 * Everything the pinned strip and the Body tab draw for one character against one cart.
 */
export class Panel {
    static __wrap(ptr) {
        const obj = Object.create(Panel.prototype);
        obj.__wbg_ptr = ptr;
        PanelFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panel_free(ptr, 0);
    }
    /**
     * @returns {PanelAttack[]}
     */
    get attacks() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_attacks(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get basic_lift() {
        const ret = wasm.__wbg_get_panel_basic_lift(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get budget_days() {
        const ret = wasm.__wbg_get_panel_budget_days(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get carried_weight() {
        const ret = wasm.__wbg_get_panel_carried_weight(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get dodge() {
        const ret = wasm.__wbg_get_panel_dodge(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get encumbrance_level() {
        const ret = wasm.__wbg_get_panel_encumbrance_level(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get encumbrance() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_encumbrance(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Set where the equipped weapons and shield want more hands than the character has.
     * @returns {string | undefined}
     */
    get hands_advisory() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_hands_advisory(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export3(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {PanelLocation[]}
     */
    get locations() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_locations(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get move() {
        const ret = wasm.__wbg_get_panel_move(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * The cart costs more than the sheet's money container holds. Nothing is refused.
     * @returns {boolean}
     */
    get overspent() {
        const ret = wasm.__wbg_get_panel_overspent(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * The gear the character arrived with, which was never charged against the budget.
     * @returns {PanelOwned[]}
     */
    get owned() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_owned(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get remaining_days() {
        const ret = wasm.__wbg_get_panel_remaining_days(this.__wbg_ptr);
        return ret;
    }
    /**
     * Every skill GCS resolved a level for, which the Kit tab holds its checklist against.
     * @returns {PanelSkill[]}
     */
    get skills() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_skills(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The spells a grimoire page may name, read off the sheet as it arrived.
     * @returns {PanelSpell[]}
     */
    get spells() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panel_spells(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get spent_days() {
        const ret = wasm.__wbg_get_panel_spent_days(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {PanelAttack[]} arg0
     */
    set attacks(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_attacks(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set basic_lift(arg0) {
        wasm.__wbg_set_panel_basic_lift(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set budget_days(arg0) {
        wasm.__wbg_set_panel_budget_days(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set carried_weight(arg0) {
        wasm.__wbg_set_panel_carried_weight(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set dodge(arg0) {
        wasm.__wbg_set_panel_dodge(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set encumbrance_level(arg0) {
        wasm.__wbg_set_panel_encumbrance_level(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set encumbrance(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_encumbrance(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Set where the equipped weapons and shield want more hands than the character has.
     * @param {string | null} [arg0]
     */
    set hands_advisory(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_hands_advisory(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {PanelLocation[]} arg0
     */
    set locations(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_locations(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set move(arg0) {
        wasm.__wbg_set_panel_move(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * The cart costs more than the sheet's money container holds. Nothing is refused.
     * @param {boolean} arg0
     */
    set overspent(arg0) {
        wasm.__wbg_set_panel_overspent(this.__wbg_ptr, arg0);
    }
    /**
     * The gear the character arrived with, which was never charged against the budget.
     * @param {PanelOwned[]} arg0
     */
    set owned(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_owned(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set remaining_days(arg0) {
        wasm.__wbg_set_panel_remaining_days(this.__wbg_ptr, arg0);
    }
    /**
     * Every skill GCS resolved a level for, which the Kit tab holds its checklist against.
     * @param {PanelSkill[]} arg0
     */
    set skills(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_skills(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * The spells a grimoire page may name, read off the sheet as it arrived.
     * @param {PanelSpell[]} arg0
     */
    set spells(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panel_spells(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set spent_days(arg0) {
        wasm.__wbg_set_panel_spent_days(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) Panel.prototype[Symbol.dispose] = Panel.prototype.free;

/**
 * One weapon usage as the Weapons tab prints it. Spells are not here: the page tier that
 * sets a spell's level is the grimoire control, and its attack levels move with it.
 */
export class PanelAttack {
    static __wrap(ptr) {
        const obj = Object.create(PanelAttack.prototype);
        obj.__wbg_ptr = ptr;
        PanelAttackFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof PanelAttack)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelAttackFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panelattack_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get accuracy() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_accuracy(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get block() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_block(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * A conditional modifier, verbatim. It is printed beside the stats and folded
     * into no number, because a flat bonus is a lie for the situations it excludes.
     * @returns {string}
     */
    get conditional() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_conditional(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get damage() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_damage(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * The skills the usage defaults through, so an absent level can name what is missing.
     * @returns {string[]}
     */
    get defaults() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_defaults(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Absent where GCS resolved no level, which the tab prints as "no skill".
     * @returns {number | undefined}
     */
    get level() {
        const ret = wasm.__wbg_get_panelattack_level(this.__wbg_ptr);
        return ret === Number.MAX_SAFE_INTEGER ? undefined : ret;
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get parry() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_parry(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get range() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_range(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get reach() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_reach(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get shield_db() {
        const ret = wasm.__wbg_get_panelattack_shield_db(this.__wbg_ptr);
        return ret;
    }
    /**
     * The trait or item the usage hangs off.
     * @returns {string}
     */
    get source() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_source(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get usage() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelattack_usage(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set accuracy(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_accuracy(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set block(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_block(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * A conditional modifier, verbatim. It is printed beside the stats and folded
     * into no number, because a flat bonus is a lie for the situations it excludes.
     * @param {string} arg0
     */
    set conditional(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_conditional(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set damage(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_damage(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * The skills the usage defaults through, so an absent level can name what is missing.
     * @param {string[]} arg0
     */
    set defaults(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_defaults(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Absent where GCS resolved no level, which the tab prints as "no skill".
     * @param {number | null} [arg0]
     */
    set level(arg0) {
        wasm.__wbg_set_panelattack_level(this.__wbg_ptr, isLikeNone(arg0) ? Number.MAX_SAFE_INTEGER : (arg0) >> 0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set parry(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_parry(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set range(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_range(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set reach(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_reach(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set shield_db(arg0) {
        wasm.__wbg_set_panelattack_shield_db(this.__wbg_ptr, arg0);
    }
    /**
     * The trait or item the usage hangs off.
     * @param {string} arg0
     */
    set source(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_source(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set usage(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelattack_usage(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) PanelAttack.prototype[Symbol.dispose] = PanelAttack.prototype.free;

export class PanelLayer {
    static __wrap(ptr) {
        const obj = Object.create(PanelLayer.prototype);
        obj.__wbg_ptr = ptr;
        PanelLayerFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof PanelLayer)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelLayerFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panellayer_free(ptr, 0);
    }
    /**
     * @returns {Caveat[]}
     */
    get caveats() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellayer_caveats(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get dr() {
        const ret = wasm.__wbg_get_panellayer_dr(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellayer_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {Caveat[]} arg0
     */
    set caveats(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellayer_caveats(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set dr(arg0) {
        wasm.__wbg_set_panellayer_dr(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellayer_name(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) PanelLayer.prototype[Symbol.dispose] = PanelLayer.prototype.free;

export class PanelLocation {
    static __wrap(ptr) {
        const obj = Object.create(PanelLocation.prototype);
        obj.__wbg_ptr = ptr;
        PanelLocationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof PanelLocation)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelLocationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panellocation_free(ptr, 0);
    }
    /**
     * Set where a numeric damage-type caveat applies, which is the diagram's asterisk.
     * @returns {boolean}
     */
    get asterisk() {
        const ret = wasm.__wbg_get_panellocation_asterisk(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Caveat[]}
     */
    get caveats() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellocation_caveats(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get dr() {
        const ret = wasm.__wbg_get_panellocation_dr(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get grid_col() {
        const ret = wasm.__wbg_get_panellocation_grid_col(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get grid_row() {
        const ret = wasm.__wbg_get_panellocation_grid_row(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get hit_penalty() {
        const ret = wasm.__wbg_get_panellocation_hit_penalty(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellocation_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Caveat[]}
     */
    get inherent_caveats() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellocation_inherent_caveats(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * DR the character carries at this location before anything worn over it.
     * @returns {number}
     */
    get inherent_dr() {
        const ret = wasm.__wbg_get_panellocation_inherent_dr(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {PanelLayer[]}
     */
    get layers() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellocation_layers(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellocation_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {PanelNote[]}
     */
    get notes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellocation_notes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get roll_range() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panellocation_roll_range(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Set where a numeric damage-type caveat applies, which is the diagram's asterisk.
     * @param {boolean} arg0
     */
    set asterisk(arg0) {
        wasm.__wbg_set_panellocation_asterisk(this.__wbg_ptr, arg0);
    }
    /**
     * @param {Caveat[]} arg0
     */
    set caveats(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellocation_caveats(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set dr(arg0) {
        wasm.__wbg_set_panellocation_dr(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set grid_col(arg0) {
        wasm.__wbg_set_panellocation_grid_col(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set grid_row(arg0) {
        wasm.__wbg_set_panellocation_grid_row(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set hit_penalty(arg0) {
        wasm.__wbg_set_panellocation_hit_penalty(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellocation_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {Caveat[]} arg0
     */
    set inherent_caveats(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellocation_inherent_caveats(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * DR the character carries at this location before anything worn over it.
     * @param {number} arg0
     */
    set inherent_dr(arg0) {
        wasm.__wbg_set_panellocation_inherent_dr(this.__wbg_ptr, arg0);
    }
    /**
     * @param {PanelLayer[]} arg0
     */
    set layers(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellocation_layers(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellocation_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {PanelNote[]} arg0
     */
    set notes(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellocation_notes(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set roll_range(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panellocation_roll_range(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) PanelLocation.prototype[Symbol.dispose] = PanelLocation.prototype.free;

export class PanelNote {
    static __wrap(ptr) {
        const obj = Object.create(PanelNote.prototype);
        obj.__wbg_ptr = ptr;
        PanelNoteFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof PanelNote)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelNoteFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panelnote_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get source() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelnote_source(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get text() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelnote_text(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set source(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelnote_source(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set text(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelnote_text(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) PanelNote.prototype[Symbol.dispose] = PanelNote.prototype.free;

/**
 * One arrived row as the gear list prints it. It carries no price, because no code path
 * could have charged it, and the column a shop row prints a price in reads `owned`.
 */
export class PanelOwned {
    static __wrap(ptr) {
        const obj = Object.create(PanelOwned.prototype);
        obj.__wbg_ptr = ptr;
        PanelOwnedFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof PanelOwned)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelOwnedFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panelowned_free(ptr, 0);
    }
    /**
     * Whether the equipped lever is offered. Top-level armour and weapon rows only: a row
     * inside a container always weighs.
     * @returns {boolean}
     */
    get can_unequip() {
        const ret = wasm.__wbg_get_panelowned_can_unequip(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * The library row this one was copied from, which is the id a kit row names. A row
     * built by hand in GCS carries no source and reads as none.
     * @returns {string | undefined}
     */
    get catalogue_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelowned_catalogue_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export3(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Zero at the root of the equipment array, one inside a container, and so on.
     * @returns {number}
     */
    get depth() {
        const ret = wasm.__wbg_get_panelowned_depth(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {boolean}
     */
    get equipped() {
        const ret = wasm.__wbg_get_panelowned_equipped(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * The sheet-internal id, which is what the cart's unequipped list names.
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelowned_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * The description with every `@X@` placeholder filled in, which is how GCS prints it.
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelowned_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * What filled the placeholder, which on a grimoire page is the spell written on it.
     * @returns {string | undefined}
     */
    get replacement() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelowned_replacement(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export3(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The extended weight of the row, in the words GCS wrote it.
     * @returns {string}
     */
    get weight() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelowned_weight(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Whether the equipped lever is offered. Top-level armour and weapon rows only: a row
     * inside a container always weighs.
     * @param {boolean} arg0
     */
    set can_unequip(arg0) {
        wasm.__wbg_set_panelowned_can_unequip(this.__wbg_ptr, arg0);
    }
    /**
     * The library row this one was copied from, which is the id a kit row names. A row
     * built by hand in GCS carries no source and reads as none.
     * @param {string | null} [arg0]
     */
    set catalogue_id(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelowned_catalogue_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Zero at the root of the equipment array, one inside a container, and so on.
     * @param {number} arg0
     */
    set depth(arg0) {
        wasm.__wbg_set_panelowned_depth(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set equipped(arg0) {
        wasm.__wbg_set_panelowned_equipped(this.__wbg_ptr, arg0);
    }
    /**
     * The sheet-internal id, which is what the cart's unequipped list names.
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelowned_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * The description with every `@X@` placeholder filled in, which is how GCS prints it.
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelowned_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * What filled the placeholder, which on a grimoire page is the spell written on it.
     * @param {string | null} [arg0]
     */
    set replacement(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelowned_replacement(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * The extended weight of the row, in the words GCS wrote it.
     * @param {string} arg0
     */
    set weight(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelowned_weight(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) PanelOwned.prototype[Symbol.dispose] = PanelOwned.prototype.free;

export class PanelSkill {
    static __wrap(ptr) {
        const obj = Object.create(PanelSkill.prototype);
        obj.__wbg_ptr = ptr;
        PanelSkillFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof PanelSkill)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelSkillFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panelskill_free(ptr, 0);
    }
    /**
     * What the kit in the cart adds to this skill, already counted in `level`.
     * @returns {number}
     */
    get bonus() {
        const ret = wasm.__wbg_get_panelskill_bonus(this.__wbg_ptr);
        return ret;
    }
    /**
     * The sheet-internal node id, which is what a skill delta names.
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelskill_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get level() {
        const ret = wasm.__wbg_get_panelskill_level(this.__wbg_ptr);
        return ret;
    }
    /**
     * Name and specialization together, which is how the kit table keys a row.
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelskill_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * What the kit in the cart adds to this skill, already counted in `level`.
     * @param {number} arg0
     */
    set bonus(arg0) {
        wasm.__wbg_set_panelskill_bonus(this.__wbg_ptr, arg0);
    }
    /**
     * The sheet-internal node id, which is what a skill delta names.
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelskill_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set level(arg0) {
        wasm.__wbg_set_panelskill_level(this.__wbg_ptr, arg0);
    }
    /**
     * Name and specialization together, which is how the kit table keys a row.
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelskill_name(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) PanelSkill.prototype[Symbol.dispose] = PanelSkill.prototype.free;

/**
 * One spell a page may name.
 */
export class PanelSpell {
    static __wrap(ptr) {
        const obj = Object.create(PanelSpell.prototype);
        obj.__wbg_ptr = ptr;
        PanelSpellFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof PanelSpell)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PanelSpellFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_panelspell_free(ptr, 0);
    }
    /**
     * The number the control shows to the left of the arrow: what GCS baked for the sheet
     * the character walked in with, pages they already carry included.
     * @returns {number}
     */
    get before() {
        const ret = wasm.__wbg_get_panelspell_before(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_panelspell_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * The number the control shows to the left of the arrow: what GCS baked for the sheet
     * the character walked in with, pages they already carry included.
     * @param {number} arg0
     */
    set before(arg0) {
        wasm.__wbg_set_panelspell_before(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_panelspell_name(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) PanelSpell.prototype[Symbol.dispose] = PanelSpell.prototype.free;

/**
 * Whether a `dr_bonus` feature naming `feature_location` lands on `location_id`. The
 * diagram runs every layer through this, so a location sheet offering the catalogue rows
 * it answers true for offers exactly the rows that would show up as a layer.
 * @param {string} feature_location
 * @param {string} location_id
 * @returns {boolean}
 */
export function covers(feature_location, location_id) {
    const ptr0 = passStringToWasm0(feature_location, wasm.__wbindgen_export, wasm.__wbindgen_export2);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(location_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.covers(ptr0, len0, ptr1, len1);
    return ret !== 0;
}

/**
 * A price or a budget as the screen prints it: Days of Water, two decimals, suffix `d`.
 * @param {number} days
 * @returns {string}
 */
export function days_label(days) {
    let deferred1_0;
    let deferred1_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.days_label(retptr, days);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        deferred1_0 = r0;
        deferred1_1 = r1;
        return getStringFromWasm0(r0, r1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
    }
}

/**
 * A catalogue price, which GCS states in dollars, as the screen prints it.
 * @param {number} dollars
 * @returns {string}
 */
export function dollars_label(dollars) {
    let deferred1_0;
    let deferred1_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.dollars_label(retptr, dollars);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        deferred1_0 = r0;
        deferred1_1 = r1;
        return getStringFromWasm0(r0, r1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_export3(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Read the panel off a committed sheet against a cart. `cart_json` is a JSON array of
 * lines, each a harvested catalogue row verbatim under `row` and a positive `quantity`.
 * `deltas_json` is the `deltas` block this character is baked with in the catalogue file.
 * @param {string} sheet_json
 * @param {string} cart_json
 * @param {string} deltas_json
 * @returns {Panel}
 */
export function panel(sheet_json, cart_json, deltas_json) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passStringToWasm0(sheet_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(cart_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(deltas_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        wasm.panel(retptr, ptr0, len0, ptr1, len1, ptr2, len2);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return Panel.__wrap(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_bce6d499ff0a4aff: function(arg0, arg1) {
            const ret = Error(getStringFromWasm0(arg0, arg1));
            return addHeapObject(ret);
        },
        __wbg___wbindgen_string_get_d109740c0d18f4d7: function(arg0, arg1) {
            const obj = getObject(arg1);
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_9c31b086c2b26051: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_caveat_new: function(arg0) {
            const ret = Caveat.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_caveat_unwrap: function(arg0) {
            const ret = Caveat.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_panelattack_new: function(arg0) {
            const ret = PanelAttack.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_panelattack_unwrap: function(arg0) {
            const ret = PanelAttack.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_panellayer_new: function(arg0) {
            const ret = PanelLayer.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_panellayer_unwrap: function(arg0) {
            const ret = PanelLayer.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_panellocation_new: function(arg0) {
            const ret = PanelLocation.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_panellocation_unwrap: function(arg0) {
            const ret = PanelLocation.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_panelnote_new: function(arg0) {
            const ret = PanelNote.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_panelnote_unwrap: function(arg0) {
            const ret = PanelNote.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_panelowned_new: function(arg0) {
            const ret = PanelOwned.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_panelowned_unwrap: function(arg0) {
            const ret = PanelOwned.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_panelskill_new: function(arg0) {
            const ret = PanelSkill.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_panelskill_unwrap: function(arg0) {
            const ret = PanelSkill.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_panelspell_new: function(arg0) {
            const ret = PanelSpell.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_panelspell_unwrap: function(arg0) {
            const ret = PanelSpell.__unwrap(getObject(arg0));
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return addHeapObject(ret);
        },
        __wbindgen_object_drop_ref: function(arg0) {
            takeObject(arg0);
        },
    };
    return {
        __proto__: null,
        "./web_bg.js": import0,
    };
}

const CaveatFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_caveat_free(ptr, 1));
const PanelFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panel_free(ptr, 1));
const PanelAttackFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panelattack_free(ptr, 1));
const PanelLayerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panellayer_free(ptr, 1));
const PanelLocationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panellocation_free(ptr, 1));
const PanelNoteFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panelnote_free(ptr, 1));
const PanelOwnedFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panelowned_free(ptr, 1));
const PanelSkillFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panelskill_free(ptr, 1));
const PanelSpellFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_panelspell_free(ptr, 1));

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function dropObject(idx) {
    if (idx < 1028) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(takeObject(mem.getUint32(i, true)));
    }
    return result;
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getObject(idx) { return heap[idx]; }

let heap = new Array(1024).fill(undefined);
heap.push(undefined, null, true, false);

let heap_next = heap.length;

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    const mem = getDataViewMemory0();
    for (let i = 0; i < array.length; i++) {
        mem.setUint32(ptr + 4 * i, addHeapObject(array[i]), true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('web_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
